import { render } from "./HeroiconsOutlineSortDescending.vue?vue&type=template&id=347c92cf"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSortDescending.vue"]])

export default __exports__